import type { ButtonConfig } from '../../declare'
import { useState, useEffect } from 'react'
import { autorun, toJS } from 'mobx'
import { Button } from 'antd'
import { EasyIcon } from 'src/components'

type Props = {
  config: ButtonConfig
}
const DeleteConfirmBtn = (props: Props) => {
  const handleDel = () => {
    const { __CONTEXT__: editTable } = props.config
    const { dataSource, selectedKeys } = editTable.activeTableData
    const copyDataSource = toJS(dataSource)
    copyDataSource.forEach((item: any) => {
      selectedKeys.indexOf(item.ID) !== -1 && (item.IS_DELETED = true)
    })
    editTable.activeTable.setDataSource(copyDataSource)
    editTable.activeTable.setSelectedKeys([])
  }

  const [disabled, setDisabled] = useState(false)
  useEffect(() => autorun(() => {
    const { __CONTEXT__: editTable } = props.config
    setDisabled(!editTable.activeTableData?.selectedKeys?.length)
  }), [])

  const { __READONLY__, LABEL, ICON } = props.config
  return (
    <Button
      danger
      disabled={disabled || __READONLY__}
      icon={<EasyIcon type={ICON} defaultIcon='DeleteOutlined' />}
      onClick={handleDel}
    >{LABEL}</Button>
  )
}

export default DeleteConfirmBtn